import classnames from 'classnames';
import LoadingDots from 'components/LoadingDots';
import React, { RefObject } from 'react';
import { useTrekker } from 'utils/analytics';

const CSS = require('./RoundedButton.less');

interface RoundedButtonProps {
  isLoading?: boolean;
  children: any;
  size?: 'S' | 'M' | 'L';
  className?: string;
  inverted?: boolean;
  pink?: boolean;
  yellow?: boolean;
  sandstone?: boolean;
  onClick?: (event: any) => void;
  type?: 'reset' | 'submit' | 'button';
  disabled?: boolean;
  fullWidth?: boolean;
  invertedBorder?: boolean;
  edgeRounding?: 'slight' | 'medium' | 'full';
  [key: string]: any;
}

const RoundedButton = React.forwardRef<HTMLButtonElement, RoundedButtonProps>(
  (
    {
      disabled,
      isLoading,
      size = 'M',
      fullWidth,
      children,
      className,
      inverted,
      invertedBorder,
      onClick,
      pink,
      yellow,
      sandstone,
      type,
      edgeRounding = 'full',
      ...rest
    }: RoundedButtonProps,
    ref: RefObject<HTMLButtonElement>,
  ) => {
    const classes = classnames(CSS.Button, {
      [className]: className,
      [CSS.Inverted]: inverted,
      [CSS.InvertedBorder]: invertedBorder,
      [CSS.PinkButton]: pink,
      [CSS.YellowButton]: yellow,
      [CSS.SandstoneButton]: sandstone,
      [CSS.FullWidth]: fullWidth,
      [CSS.Large]: size === 'L',
      [CSS.Small]: size === 'S',
      [CSS.EdgeRoundedSlight]: edgeRounding === 'slight',
      [CSS.EdgeRoundedMedium]: edgeRounding === 'medium',
    });
    const trekker = useTrekker();
    const handleClick = (e) => {
      if (typeof children === 'string') {
        trekker.event('click', {
          component: ['RoundedButton'],
          buttonText: children,
        });
      } else {
        trekker.event('click', { component: ['RoundedButton'] });
      }
      onClick?.(e);
    };
    return (
      <button
        ref={ref}
        type={type}
        className={classes}
        disabled={disabled || isLoading}
        onClick={handleClick}
        {...rest}
      >
        {!isLoading && children}
        {isLoading && (
          <LoadingDots
            isWhite={!(inverted || invertedBorder)}
            className={CSS.Loading}
          />
        )}
      </button>
    );
  },
);

export default RoundedButton;
